import { EEventType } from './../../../../enums/EEventType';
import { ICheckboxData, ISelectData } from './../../../../types/data';
import OY from "../../../../types/OY";
import styles from './index.module.less';
import template from './index.art';
import { IOYSpecificationProps, IOYSpecificationState } from "./const";
import { jeact } from '../../../../decorators/jeact';

@jeact({ autoRender: true })
export default class OYSpecification extends OY<IOYSpecificationProps, IOYSpecificationState> {
  static displayName = 'OYSpecification';

  static defaultProps: Partial<IOYSpecificationProps> = {
    name: '',
    value: {}
  };

  state: IOYSpecificationState = {}

  $node = {}

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  // 外部接管.不用内部生成了
  // renderButton() {
  //   this.$el.find('oy-button').OYButton({
  //     onClick: () => {
  //       this.eventEmitter.emit(EEventType.onSearch)
  //     }
  //   })
  // }

  renderRangeInput() {
    this.$el.find('oy-input-range').each((index, element) => {
      const $element = $(element);
      const key = $element.attr('key');
      $element.OYInputRange({
        value: this.props.value[key] || [],
        valtype: 'positiveFloat',
        onChange: (value: string[]) => {
          if (key === 'lenghtSpec') {
            const $lenghtSpec = this.$el.find('div[key=lenghtSpec]');
            const $lenghtSpecInputStop = $lenghtSpec.find('input[name=stop]')
            if ($lenghtSpecInputStop.attr('disabled')) {
              const inputValue = value[0];
              $lenghtSpecInputStop.val(inputValue)
              return this.eventEmitter.emit(EEventType.onChange, [inputValue, inputValue], key)
            }

            this.eventEmitter.emit(EEventType.onChange, value, key)
          } else {
            this.eventEmitter.emit(EEventType.onChange, value, key)
          }
        }
      })
    })
  }

  renderSelect() {
    this.$el.find('oy-select').each((_index, element) => {
      const $element = $(element);
      const key = $element.attr('key');
      const data = (this.props.info[key] as ISelectData);
      const value = this.props.value[key][0] || '';
      $element.OYSelect({
        value,
        info: data.info,
        placeholder: data.name,
        onChange: (val: string) => {
          this.$el.find('div[key=lenghtSpec] input').val('');
          this.handleSelectValue(val)
          this.eventEmitter.emit(EEventType.onChange, [val], key)
        }
      })

      setTimeout(() => {
        this.handleSelectValue(value, false)
      }, 50)
    })
  }

  renderCheckbox() {
    this.$el.find('oy-checkbox').each((index, element) => {
      const $element = $(element);
      const key = $element.attr('key');
      const data = (this.props.info[key] as ICheckboxData);
      $element.OYCheckbox({
        value: this.props.value[key] || [],
        info: data.info || [],
        onChange: (value: string[]) => {
          this.eventEmitter.emit(EEventType.onChange, value, key)
        }
      })
    })
  }

  setNode() {

  }

  private handleSelectValue(value: string, emit = true) {
    const $lenghtSpec = this.$el.find('div[key=lenghtSpec]');
    const $lenghtSpecInputStart = $lenghtSpec.find('input[name=start]')
    const $lenghtSpecInputStop = $lenghtSpec.find('input[name=stop]')

    $lenghtSpecInputStart.removeAttr('disabled')
    $lenghtSpecInputStop.removeAttr('disabled')

    switch (value) {
      case '2': // 卷
        $lenghtSpecInputStart.attr('disabled', 'disabled').val('0');
        $lenghtSpecInputStop.attr('disabled', 'disabled').val('0');
        $lenghtSpecInputStop.parent().hide().prev().hide(); // 隐藏后面的输入框
        emit && this.eventEmitter.emit(EEventType.onChange, ['0', '0'], 'lenghtSpec')
        break;
      case '3': // 定尺
        $lenghtSpecInputStop.attr('disabled', 'disabled');
        $lenghtSpecInputStop.parent().hide().prev().hide(); // 隐藏后面的输入框
        emit && this.eventEmitter.emit(EEventType.onChange, ['', ''], 'lenghtSpec')
        break;
      default: // 自定义长度
        $lenghtSpecInputStop.parent().show().prev().show();
        emit && this.eventEmitter.emit(EEventType.onChange, ['', ''], 'lenghtSpec')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/OYFilter/components/OYSpecification/index.ts